import { baseApi as api } from 'shared/api/baseApi';
import { CHANNEL_LANGUAGES, COUNTRIES, OFFER_CATEGORIES } from 'shared/consts';
import { CATEGORIES } from 'shared/consts';
import { IMetaInterface } from 'shared/typings';
import { getOptionsFromSlug } from 'shared/utils';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		appConfigRetrieve: build.query<AppConfigRetrieveApiResponse, AppConfigRetrieveApiArg>({
			query: () => ({ url: `/api/app_config/` }),
		}),
		metaRetrieve: build.query<IMetaInterface, MetaRetrieveApiArg>({
			query: () => ({ url: `/api/meta/` }),
			// MANUAL TRANSFORM_RESPONSE - DO NOT DELETE
			transformResponse: (data: MetaRetrieveApiResponse): IMetaInterface => ({
				balance_currencies: data.balance_currencies,
				currencies: data.currencies,
				offerCategoriesOptions: getOptionsFromSlug(data.offer_categories, OFFER_CATEGORIES),
				channelCategoryOptions: getOptionsFromSlug(data.channel_categories, CATEGORIES),
				channelLanguagesOptions: getOptionsFromSlug(data.channel_languages, CHANNEL_LANGUAGES),
				countryOptions: data.countries
					.map(({ alpha_2, name }) => ({
						value: alpha_2,
						label: COUNTRIES[alpha_2] || name,
					}))
					.sort((a, b) => a.label?.localeCompare(b.label)),
			}),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type AppConfigRetrieveApiResponse = /** status 200  */ AppConfigRead;
export type AppConfigRetrieveApiArg = void;
export type MetaRetrieveApiResponse = /** status 200  */ Meta;
export type MetaRetrieveApiArg = void;
export type Balance = {
	currency: string;
};
export type BalanceRead = {
	balance_amount: string;
	on_hold_amount: string;
	approved_amount: string;
	currency: string;
};
export type User = {
	user_id: string;
	email: string;
	is_banned: boolean;
	balance: Balance | null;
	language: string;
	tg_first_name: string;
	tg_last_name: string;
	tg_username: string;
	tg_photo_url: string;
};
export type UserRead = {
	user_id: string;
	email: string;
	is_banned: boolean;
	balance: BalanceRead | null;
	language: string;
	tg_first_name: string;
	tg_last_name: string;
	tg_username: string;
	tg_photo_url: string;
};
export type AppConfig = {
	user: User | null;
	is_super_login: boolean;
	payouts_available: boolean;
};
export type AppConfigRead = {
	user: UserRead | null;
	is_super_login: boolean;
	payouts_available: boolean;
};
export type OfferCategoryMeta = {
	slug: string;
	name: string;
};
export type ChannelCategoryMeta = {
	slug: string;
	name: string;
};
export type ChannelLanguageMeta = {
	slug: string;
	name: string;
};
export type CurrencyMeta = {
	code: string;
	sign: string;
};
export type CountryMeta = {
	alpha_2: string;
	name: string;
};
export type Meta = {
	offer_categories: OfferCategoryMeta[];
	channel_categories: ChannelCategoryMeta[];
	channel_languages: ChannelLanguageMeta[];
	currencies: CurrencyMeta[];
	balance_currencies: CurrencyMeta[];
	countries: CountryMeta[];
};
